/**
 * Вытаскиваем название компонента из события
 *
 * @method
 * @private
 */
function _component(eventName) {
  const eventNameArr = eventName.split(':');

  return eventNameArr[eventNameArr.length - 1];
}

export default _component;
